import { inject, Pipe, PipeTransform } from '@angular/core';
import { AppdataService } from '../service/appdata.service';
import { Category } from '../interfaces/categoryInterface';

@Pipe({
  name: 'getCategoryNameById',
  standalone: false
})
export class GetCategoryNameByIdPipe implements PipeTransform {


  dataService = inject(AppdataService);

  transform(id: string): string {
    let cats = this.dataService.categories.getValue();
    let result = cats.find(type => type.id === id)?.name || id;
    return result;
  }

}
